import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";
import heroImage from "@/assets/hero-mobility.jpg";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Green Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="GoPass Mobilidade - Transformando o futuro do transporte"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1e4d0b] opacity-90"></div>
      </div>

      {/* Conteúdo */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-7xl font-bold mb-6 leading-snug md:leading-tight">
            Transformando a
            <span className="block text-[#F1F1F1] drop-shadow-md">
              Mobilidade Urbana
            </span>
          </h1>

          <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl mx-auto">
            Conheça os cases de sucesso que estão revolucionando o transporte no
            Brasil. Mais de <strong>500 mil usuários</strong> já confiam na
            GoPass.
          </p>

          {/* Botões */}
          <div className="flex flex-col items-center space-y-4">
            <a href="#cases">
              <Button
                variant="outline"
                size="lg"
                className="text-lg px-8 py-4 border-white/30 text-white hover:bg-white/20 bg-white/10"
              >
                <Play className="mr-2 w-5 h-5" />
                Ver Cases de Sucesso
              </Button>
            </a>

            <a
              href="https://calendly.com/app-gopass/20min"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                size="lg"
                className="text-lg px-8 py-4 border-blue-300 text-white bg-blue-500/10 hover:bg-blue-500/20"
              >
                Agendar Reunião Online
              </Button>
            </a>
          </div>
        </div>

        {/* Estatísticas */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white">300K+</div>
            <div className="text-white/80 text-sm uppercase tracking-wide">
              Usuários Ativos
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white">40+</div>
            <div className="text-white/80 text-sm uppercase tracking-wide">
              Cidades
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white">50M+</div>
            <div className="text-white/80 text-sm uppercase tracking-wide">
              Viagens Realizadas
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white">98%</div>
            <div className="text-white/80 text-sm uppercase tracking-wide">
              Satisfação
            </div>
          </div>
        </div>
      </div>

      {/* Indicador de scroll */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#999999] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#CCCCCC] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
